import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'

import { map } from 'rxjs/operators'
import { OidcService } from '@core/authentication/oidc/oidc.service'
import { OidcStore } from '@core/store/oidc/oidc.store'
import { StartupStore } from '@core/store/startup/startup.store'

export const authGuard: CanActivateFn = (_route, state) => {
  const manager = inject(OidcService)
  const oidcStore = inject(OidcStore)
  const startupStore = inject(StartupStore)

  return manager.getUser().pipe(
    map((oidc) => {
      if (!oidc) {
        // If route is not authorized, sign in starts with route requested
        oidcStore.signInRedirect(state.url)
      } else {
        startupStore.startup(oidc)
      }
      return !!oidc
    }),
  )
}
